












import Vue from 'vue';

export default Vue.extend({
  name: 'SearchResult',
  props: {
    searchText: String,
    value: String,
  },
});
